"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "customValidators", {
    enumerable: true,
    get: function() {
        return customValidators;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _validator = /*#__PURE__*/ _interop_require_default(require("validator"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const customValidators = {
    isCurrency: _validator.default['isFloat'],
    isURL: (str, extraProps)=>{
        return (0, _nocodbsdk.isValidURL)(str, _extends({}, extraProps != null ? extraProps : {}, {
            require_tld: process.env.NC_ALLOW_LOCAL_HOOKS !== 'true'
        }));
    }
};
